import React, {ReactNode} from "react";

export const EmptyChart = ({children = "No data"}: {children?: ReactNode}) => (
  <div className="no-data">{children}</div>
);
